import { LessonProblem } from '@yandex-int/k-common/typings';
import cx from 'classnames';
import { Paginator } from 'platform-components';
import { PAGINATOR_BUTTON_VIEW, PAGINATOR_THEME } from 'platform-components/constants';
import { Page } from 'platform-components/src/components/paginator/types';
import React from 'react';
import { connect } from 'react-redux';

import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';

import './problem-view__paginator.scss';

interface OwnProps {
    onProblemItemClick: (problemId: number | null) => void;
    innerRef?: React.Ref<HTMLDivElement>;
    mix?: string;
}

interface StoreProps {
    selectedProblemId: number | null;
    problems: Array<LessonProblem>;
}

interface Props extends OwnProps, StoreProps {}

export const ProblemsPaginator = (props: Props) => {
    const { innerRef, problems, selectedProblemId, onProblemItemClick, mix } = props;

    if (problems.length < 2) {
        return null;
    }

    const pages: Array<Page> = problems.map((problem, index) => {
        const problemId = problem.problem?.id;

        return {
            number: index,
            selected: problem.id === selectedProblemId,
            onClick: () => onProblemItemClick(problemId || null),
            disabled: false,
            text: (index + 1).toString(),
            view: PAGINATOR_BUTTON_VIEW.DEFAULT,
        };
    });

    return (
        <div className={cx('problem-view__paginator-wrapper', mix)} ref={innerRef}>
            <Paginator
                key={selectedProblemId || undefined}
                mix="problem-view__paginator"
                onDownButtonClick={() => {}}
                onUpButtonClick={() => {}}
                pages={pages}
                theme={PAGINATOR_THEME.WHITE}
            />
        </div>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    return {
        selectedProblemId: lessonViewSelectors.getSelectedProblemLinkId(storeState),
        problems: lessonViewSelectors.getLessonViewProblems(storeState),
    };
};

export default connect(mapStateToProps)(ProblemsPaginator);
